const EXPIRY_SECONDS = 3 * 60;

/** Matches Descope flow component default poll interval. */
const POLL_INTERVAL_MS = 2000;

export function formatPollingTime(seconds: number): string {
	const m = Math.floor(seconds / 60);
	const s = seconds % 60;
	return `${m}:${s.toString().padStart(2, "0")}`;
}

export { EXPIRY_SECONDS, POLL_INTERVAL_MS };

export function getPollingEmail(
	form: Record<string, unknown>,
	context?: Record<string, unknown>
): string {
	const fromForm = form.loginId ?? form.email;
	if (typeof fromForm === "string" && fromForm) return fromForm;
	const fromCtx = context?.loginId ?? context?.email;
	if (typeof fromCtx === "string" && fromCtx) return fromCtx;
	return "you@company.com";
}

/** Magic-link verification number from Descope BYOS `context.linkId`. */
export function getLinkId(context?: Record<string, unknown>): string | number | null {
	const raw = context?.linkId;
	if (typeof raw === "number" && !Number.isNaN(raw)) return raw;
	if (typeof raw === "string" && raw.trim() !== "") return raw.trim();
	return null;
}
